import { LogItemLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/LogItemLayout';
import {
  BaseEventWithReason,
  BaseEventWithReasonProps,
} from '@features/components/ClinicalData/components/ClinicalLog/components/BaseEventWithReason';

export const DryRunItem = ({
  shared,
  description,
  dispositionReason,
  dispositionSpecification,
  event,
  onShareClick,
}: BaseEventWithReasonProps) => {
  return (
    <LogItemLayout className="bg-danger-70 text-danger-5">
      <BaseEventWithReason
        event={event}
        description={description}
        dispositionReason={dispositionReason}
        dispositionSpecification={dispositionSpecification}
        shared={shared}
        onShareClick={onShareClick}
      />
    </LogItemLayout>
  );
};
